<template>
  <div class="r-auth-forgot-password row">
    <div class="col-6 recycling-image"></div>
    <div class="col-6">
      <div style="width: 80%; margin: 0 auto;">
        <br>
        <h1 class="mt-5">Welcome to Recovinyl</h1>
        <h4 class="mt-3" style="opacity: 0.7; font-size: 20px;">We make it easy for you to ...</h4>
        <br>

        <h1 class="mt-5 mb-5">Forgot my password</h1>
        <form
          style="padding-bottom: 100px;"
          class="mt-2"
          method="post"
          name="test"
          @submit.prevent="handleSubmit"
        >
          <base-text
            name="email"
            label="Email address"
            v-validate="'required|email'"
            v-model="email"
            :err="errors.collect('email')"
          />

          <div class="row mt-5">
            <div class="col-6 text-left">
              <base-button
                radius="bl"
                component-class="blue filled"
                type="button"
                @click.native="$router.push({name: 'auth-login'})"
              >
                <i class="fas fa-sign-in-alt mr-3"></i> Login screen
              </base-button>
            </div>
            <div class="col-6 text-right">
              <base-button radius="br" component-class="green filled" type="submit">
                Proceed
                <i class="fas fa-arrow-right ml-3"></i>
              </base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/inputs/button/BaseButton';
import BaseText from '@/components/inputs/text/BaseText';

export default {
  data() {
    return {
      email: '',
    };
  },

  methods: {
    handleSubmit() {
      console.log('implement in new wersion');
    }
  },

  mounted() {
    this.$store.commit('app/setContainerClass', 'pt-0 pb-0');
  },

  beforeDestroy() {
    this.$store.commit('app/setContainerClass', '');
  },

  components: {
    'base-button': BaseButton,
    'base-text': BaseText
  }
};
</script>
